import Repository from './Repository'
import TokenService from '../helpers/token'

const resource = `${Repository.defaults.baseURL}/order`
const resourceTutor = `${Repository.defaults.baseUrlTutor}`
const resourceV2 = `${Repository.defaults.baseURL}/v2/order`
const resourceOrder = `${Repository.defaults.orderApi}`

export default {

  async create(params) {
    const response = await Repository.post(`${resource}`, params, {
      headers: TokenService.getHeader(),
    })
    return response
  },
  async createV2(params) {
    const response = await Repository.post(`${resourceV2}`, params, {
      headers: TokenService.getHeader(),
    })
    return response
  },

  async list(params) {
    const response = await Repository.get(`${resource}`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },
  async detail(id) {
    const response = await Repository.get(`${resource}/${id}`, {
      headers: TokenService.getHeader(),
    })
    return response
  },
  async detailV2(id) {
    const response = await Repository.get(`${resourceV2}/${id}/trail`, {
      headers: TokenService.getHeader(),
    })
    return response
  },

  async update(id, params) {
    const response = await Repository.patch(`${resource}/${id}`, params, {
      headers: TokenService.getHeader(),
    })
    return response
  },
  async updateV2(id, params) {
    const response = await Repository.patch(`${resourceV2}/${id}`, params, {
      headers: TokenService.getHeader(),
    })
    return response
  },

  async changeStatus(id, body) {
    const response = await Repository.patch(`${resource}/${id}/status`, body, {
      headers: TokenService.getHeader(),
    })
    return response
  },

  async exportExcelContact(params = {}) {
    const response = await Repository.get(`${resource}/export/excel`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },

  async getEndDate(products) {
    const response = await Repository.post(`${resource}/product-end-date`, products, {
      headers: TokenService.getHeader()
    })
    return response
  },

  async confirmPayment(params) {
    const response = await Repository.post(`${resource}/confirm-payment`, params, {
      headers: TokenService.getHeader()
    })
    return response
  },

  async getListOrderAccount(params) {
    const response = await Repository.get(`${resource}/${params.orderId}/account`, {
      headers: TokenService.getHeader()
    });
    return response;
  },

  async ctvCreate(params) {
    const response = await Repository.post(`${resource}/ctv-create`, params, {
      headers: TokenService.getHeader(),
    })
    return response
  },

  async exportExcelContactDoiSoat(params = {}) {
    const response = await Repository.get(`${resource}/export/excel-order-doisoat`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },
  async exportExcelOrderAccountant(params = {}) {
    const response = await Repository.get(`${resource}/export/excel-order-accountant`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },

  // đơn hàng bên tutor
  async getTransferOrderStudents(contactId) {
    const response = await Repository.get(`${resourceTutor}/transfer/get-transfer-product?contactId=${contactId}`, {
        headers: TokenService.getHeader(),
    })
    return response;
  },
  async listV2(params) {
    const response = await Repository.get(`${Repository.defaults.baseURL}/v2/order`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },
  async getTrailOfOrder(orderId) {
    const response = await Repository.get(`${Repository.defaults.baseURL}/v2/order/${orderId}/trail`, {
      headers: TokenService.getHeader(),
    })
    return response
  },
  async getListOrderPaymentCheckout(params){
    const response = await Repository.get(`${Repository.defaults.baseURL}/transaction-order`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },
  async getOrderDetailByCode(code) {
    const params = {
      code: code,
    }
    const response = await Repository.get(`${Repository.defaults.baseURL}/order/v3/list`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },
  async getListCountStatusOrderPaymentCheckout(params){
    const response = await Repository.get(`${Repository.defaults.baseURL}/transaction-order/transactionStatusCounts`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },
  async getListBanks(){
    const response = await Repository.get(`${Repository.defaults.baseURL}/transaction-order/banks`, {
      headers: TokenService.getHeader(),
    })
    return response
  },
  async linkOrderWithTransaction(body){
    const response = await Repository.patch(`${Repository.defaults.baseURL}/transaction-order/checkingOrder`,body, {
      headers: TokenService.getHeader(),
    })
    return response
  },
  async linkOrderWithTransactionApproved(body){
    const response = await Repository.patch(`${Repository.defaults.baseURL}/transaction-order/recheckingOrder`,body, {
      headers: TokenService.getHeader(),
    })
    return response
  },

  async approvedTransaction(transactionId){
    const response = await Repository.patch(`${Repository.defaults.baseURL}/transaction-order/approvedTransaction`, {transactionId: transactionId}, {
      headers: TokenService.getHeader(),
    })
    return response
  },

  async deniedTransaction(body){
    const response = await Repository.patch(`${Repository.defaults.baseURL}/transaction-order/refuseApprovedTransaction`, body, {
      headers: TokenService.getHeader(),
    })
    return response
  },

  async changeTransactionStatus(body){
    const response = await Repository.post(`${Repository.defaults.baseURL}/transaction-order/changeStatus`, body, {
      headers: TokenService.getHeader(),
    })
    return response
  },

  async exportExcelOrderPaymentChecklist(params){
    const response = await Repository.get(`${Repository.defaults.baseURL}/transaction-order/export`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },

  async getListHistoryLogs(transactionId){
    const response = await Repository.get(`${Repository.defaults.baseURL}/transaction-order/actionHistories?transactionId=${transactionId}&limit=20&offset=0`, {
      headers: TokenService.getHeader(),
    })
    return response
  },

  async getListApproveBy(){
    const response = await Repository.get(`${Repository.defaults.baseURL}/transaction-order/approvedBy`, {
      headers: TokenService.getHeader(),
    })
    return response
  },

  async getListPaymentHub(params) {
    const response = await Repository.get(`${resourceOrder}/console/payment`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },

  async getCountStatusListPaymentHub(params) {
    const response = await Repository.get(`${resourceOrder}/console/payment/count`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },

  async getListOrder(params) {
    const response = await Repository.get(`${resourceOrder}/console/orders`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },

  async getCountStatusListOrder(params) {
    const response = await Repository.get(`${resourceOrder}/console/orders/count`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },

  async getFilterFormOptions() {
    const response = await Repository.get(`${resourceOrder}/console/payment/get-filter-form-options`, {
      headers: TokenService.getHeader(),
    })
    return response
  },

  async getGroupProduct() {
    const response = await Repository.get(`${Repository.defaults.baseURL}/product-group?limit=100`, {
      headers: TokenService.getHeader(),
    })
    return response
  },

  async inquirePaymentHub(txn_no) {
    const response = await Repository.get(`${Repository.defaults.paymentApi}/console/payment/${txn_no}/inquire`, {
      headers: TokenService.getHeader(),
    })
    return response
  },

  async exportExcelPaymentHub(params){
    const response = await Repository.get(`${resourceOrder}/console/payment/export`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },

  async getListLmsCodes(params){
    const response = await Repository.get(`${resourceOrder}/api/bus-combo?active=1`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },
}
